import './Businesses/index.js';
import { PRODUCT_LIST as PRODUCT_LIST$1, PRODUCT_LIST_UK as PRODUCT_LIST_UK$1 } from './Businesses/constants.js';
import messages$1 from './Businesses/messages.js';
import './Company/index.js';
import { PRODUCT_LIST as PRODUCT_LIST$3, PRODUCT_LIST_UK as PRODUCT_LIST_UK$3 } from './Company/constants.js';
import messages$3 from './Company/messages.js';
import './Developers/index.js';
import { PRODUCT_LIST as PRODUCT_LIST$2, PRODUCT_LIST_UK as PRODUCT_LIST_UK$2 } from './Developers/constants.js';
import messages$2 from './Developers/messages.js';
import './Individuals/index.js';
import { PRODUCT_LIST, PRODUCT_LIST_UK } from './Individuals/constants.js';
import messages from './Individuals/messages.js';
import './Institutions/index.js';
import { PRODUCT_LIST as PRODUCT_LIST$4, PRODUCT_LIST_UK as PRODUCT_LIST_UK$4 } from './Institutions/constants.js';
import messages$4 from './Institutions/messages.js';
import IndividualsContent from './Individuals/Individuals.js';
import BusinessesContent from './Businesses/Businesses.js';
import DevelopersContent from './Developers/Developers.js';
import CompanyContent from './Company/Company.js';
import InstitutionsContent from './Institutions/Institutions.js';
const TRAPDOOR_CONTENT_MAP = {
  individuals: IndividualsContent,
  businesses: BusinessesContent,
  developers: DevelopersContent,
  company: CompanyContent,
  institutions: InstitutionsContent
};
const TRAPDOOR_CONTENT_MAP_UK = {
  individuals: IndividualsContent,
  businesses: BusinessesContent,
  developers: DevelopersContent,
  company: CompanyContent,
  institutions: InstitutionsContent
};
const TRAPDOOR_MESSAGES_MAP = {
  individuals: messages,
  businesses: messages$1,
  developers: messages$2,
  company: messages$3,
  institutions: messages$4
};
const TRAPDOOR_LINKS_MAP = {
  individuals: PRODUCT_LIST,
  businesses: PRODUCT_LIST$1,
  developers: PRODUCT_LIST$2,
  company: PRODUCT_LIST$3,
  institutions: PRODUCT_LIST$4
};

// Trapdoor for UK users has slight difference for individuals and businesses as per request from UK FinProm compliance team.
// Removed "Burrow" under individuals and moved "Private Client" from individuals to businesses.
const TRAPDOOR_LINKS_MAP_UK = {
  individuals: PRODUCT_LIST_UK,
  businesses: PRODUCT_LIST_UK$1,
  developers: PRODUCT_LIST_UK$2,
  company: PRODUCT_LIST_UK$3,
  institutions: PRODUCT_LIST_UK$4
};
export { TRAPDOOR_CONTENT_MAP, TRAPDOOR_CONTENT_MAP_UK, TRAPDOOR_LINKS_MAP, TRAPDOOR_LINKS_MAP_UK, TRAPDOOR_MESSAGES_MAP };
//# sourceMappingURL=TrapdoorContent.js.map
